export default {
  color: {},
  nameScreen: {
    txt2img: 'txt2img',
    img2img: 'img2img',
    loraHistory: 'loraHistory'
  },
  keyScreen: {
    trainLora: 1,
    img2img: 2,
    loraHistory: 3,
    renderHistory: 4
  },
  ICONS: {},
  image: {},
  renderType: {
    hand: 'hand',
    background: 'background'
  },
  loraType: {
    AI: 2,
    normal: 1,
    txt2Img: 3,
    img2Img: 4,
    fixHandTxt2Img: 5,
    fixHandImg2Img: 6,
    fixBGImg2Img: 6
  },
  processing: {
    PROCESSING: 1,
    SUCCESS: 2,
    FAIL: 3
  },
  gender: [
    {
      gender: '男',
      value: 1
    },
    {
      gender: '女',
      value: 2
    }
  ]
}
